// Commission Payable Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get commissionPayableList from backend then update commissionPayableList in vuex store ***** //
export const updateCommissionPayableList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('commission_payable_index', {
      params: params
    })
    commit('updateCommissionPayableList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch commissionPayableInfo from backend ***** //
export const fetchCommissionPayableInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`commission_payable_show/${payload}`)
    commit('updateCommissionPayableInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch commissionPayableBalanceDetails from backend ***** //
export const fetchCommissionPayableBalanceDetails = async ({ commit }) => {
  try {
    const result = await Axios.get(`commission_payable_balance_details`)
    commit('updateCommissionPayableBalanceDetails', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
